/* eslint-disable */
var utils = require('./nav-utils');
var mapLayer = null;
var contentLayer = cube.$id('layerCartridge');
var layerContainer = cube.$('.header-bottom__layer-container');

// Account Layer
var openAccount = module.exports.openAccount = function(elt) {
  closeLayer(displayContent);
  function displayContent() {
    cube.$('html').classList.add('layerPreventScroll');
    var isAuth = false;
    if (tc_vars.user_status === 'authenticated') {
      isAuth = true;
    }
    openCartridgeLayer(elt, function() {
      if (isAuth) {
        contentLayer.innerHTML = cube.$('#header-my-account .dkt-header__nav__submenu__inner').innerHTML;
        $('body').on('click', '#layerCartridge #storeLink', function(e) {
          e.preventDefault();
          openStores(cube.$('.dkt-toolbar__item[data-layer="stores"]'));
        });
        cube.event.send('reload-header-my-account');
      } else {
        cube.$('body').classList.add('login');
        require('../../authentication/login/login').init();
        if (cube.$('.getCaptchaScript')) {
          $.getScript(cube.$('.getCaptchaScript').src);
        }
        $('.selectpicker.mobile-country-code').selectpicker('render');
      }
    });
  }
};

// Stores Layer
var openStores = module.exports.openStores = function(elt) {
  closeLayer(displayContent);
  function displayContent() {
    cube.$('html').classList.add('layerPreventScroll');
    cube.stores.getDefaultStore(storeId => {
      if (storeId && storeId !== null && cube.$('#header-store .dkt-header__nav__submenu__inner')) {
        openCartridgeLayer(elt);
        contentLayer.innerHTML = cube.$('#header-store .dkt-header__nav__submenu__inner').innerHTML;
        $('body').on('click', '#layerCartridge .store-locator-link', function(e) {
          e.preventDefault();
          openMapLayer(elt);
        });
      } else {
        openMapLayer(elt);
      }
    });
  }
};

// Contact Layer
var openContact = module.exports.openContact = function(elt) {
  closeLayer(displayContent);
  function displayContent() {
    openCartridgeLayer(elt);
    contentLayer.innerHTML = cube.$('#header-help .dkt-header__nav__submenu__inner').innerHTML;
  }
};

var openMapLayer = function(elt, callback){
  var navMapLayer = cube.$('#navMap');
  var layerHeight = calculateSize();
  if (tc_vars.page_name === '/home' && cube.$id('homeToolbarItem').classList.contains('dkt-toolbar__item--active')) {
    cube.$id('homeToolbarItem').classList.remove('dkt-toolbar__item--active');
  }
  //set menu active
  elt.classList.add('dkt-toolbar__item--active');

  if (cube.$('.header-bottom__layer-container--open') && elt.dataset.layer === "stores") {
    navMapLayer.style.transition = 'none';
  }

  navMapLayer.classList.add('header-bottom__layer-container--open');
  navMapLayer.style.maxHeight = layerHeight + 'px';

  //set layer title
  $('.layer-container__title-container').find('.layer-container__title').text(elt.dataset.title);

  // Init map
  if (mapLayer == null) {
    setTimeout(() => {
      mapLayer = new cube.woosmap.Map(cube.$id('navMapContainer'), () => {
        mapLayer.displayStores();
        require('./nav-mobile-map').init(mapLayer);
      });
    }, 400);
  }
};

// Open Layer containing a cartridge
var openCartridgeLayer = function(elt, callback) {
  // LI is ACTIVE > return;
  var layerHeight = calculateSize();
  cube.$('html').classList.add('layerPreventScroll');

  if (tc_vars.page_name === '/home' && cube.$id('homeToolbarItem').classList.contains('dkt-toolbar__item--active')) {
    cube.$id('homeToolbarItem').classList.remove('dkt-toolbar__item--active');
  }
  elt.classList.add('dkt-toolbar__item--active');
  layerContainer.classList.add('header-bottom__layer-container--open');
  layerContainer.style.maxHeight = layerHeight + 'px';

  $('.layer-container__title-container').find('.layer-container__title').text(elt.dataset.title);

  if (elt.dataset.tPath && elt.dataset.tUrl) {
    utils.reloadLayerCatridge(elt.dataset.tPath, elt.dataset.tUrl, callback);
  }
};

// Close layer action
var closeLayer = module.exports.closeLayer = function(callback) {
  removeSelectedClass();

  var nav = require('./navigation-v2');
  if ($('#js-navigation-back').is(':visible')) {
    $('#js-navigation-back').trigger('click').removeClass().addClass('navigation__header__back');
    nav.navRefresh(cube.$$('.navigation__entry--right-slide'));
  }

  if (tc_vars.page_name === '/home' && !cube.$id('homeToolbarItem').classList.contains('dkt-toolbar__item--active')) {
    cube.$id('homeToolbarItem').classList.add('dkt-toolbar__item--active');
  }
  cube.$('html').classList.remove('layerPreventScroll');
  var layersList = document.querySelectorAll(".header-bottom__layer-container");
  for (var i = 0; i < layersList.length; i++) {
    // do something with myNodeList[i]
    layersList[i].classList.remove('header-bottom__layer-container--open');
    layersList[i].style.maxHeight = 0 + 'px';
    layersList[i].style.removeProperty('transition');
  }

	cube.$id('js-navigation').classList.remove('navigation--open');
  cube.$id('js-navigation').style.maxHeight = 0 + 'px';

  if (typeof callback === "function") {
    setTimeout(function() {
      callback();
    }, 400);
  }
};

var calculateSize = function () {
  var w = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0],
      x = w.innerWidth || e.clientWidth || g.clientWidth,
      y = w.innerHeight || e.clientHeight || g.clientHeight;
  return y;
};

var removeSelectedClass = function() {
  cube.$('.dkt-toolbar__list').querySelectorAll('.dkt-toolbar__item').classList.remove('dkt-toolbar__item--active');
};

// Map " Layer Name <-> Function to execute on Opening "
module.exports.list = {
  'account': openAccount,
  'stores': openStores,
  'contact': openContact,
};



// WEBPACK FOOTER //
// ./src/modules-es5/commons/layout/nav-mobile-actions.js